// pages/SuperadminEntry.jsx
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SuperAdminDashboard from "./../pages/SuperAdminDashboard";

const DEFAULT_TAB = "organizatii";

export default function SuperadminEntry() {
  const navigate  = useNavigate();
  const location  = useLocation();

  // dacă nu există ?tab=..., facem redirect cu replace
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get("tab")) {
      navigate(`/superadmin?tab=${DEFAULT_TAB}`, { replace: true });
    }
  }, [location.search, navigate]);

  return <SuperAdminDashboard />;
}
